
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';

//i18n
import { withNamespaces } from 'react-i18next';

// users
import user1 from '../../../assets/images/users/avatar-1.jpg';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            title: "My Account"
        };
        this.toggle = this.toggle.bind(this);
    }


    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    render() {

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle style={{color:"#fff"}} className="btn waves-effect" id="page-header-user-dropdown" tag="button">
                        <span className="d-none d-xl-inline-block ml-2 mr-1">
                            {this.state.title}
                        </span>
                        <i className="fa fa-fw fa-bars font-size-16 align-middle"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag="a" href="/contacts-profile">
                            <i className="bx bx-user font-size-16 align-middle mr-1"></i>
                            {this.props.t('Account')}
                        </DropdownItem>
                        {false && <DropdownItem tag="a" href="/ecommerce-orders">
                            <i className="bx bx-wallet font-size-16 align-middle mr-1"></i>
                            {this.props.t('Transactions')}
                        </DropdownItem>}
                        <div className="dropdown-divider"></div>
                        <Link to="/" className="dropdown-item">
                            <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                            <span>{this.props.t('Logout')}</span>
                        </Link>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export default withRouter(withNamespaces()(ProfileMenu));
